export interface THardwareCategory {
  id: number;
  name: string;
  description: string;
  image: string;
}

export interface THardwareSku {
  code: string;
  name: string;
  description: string;
  image: string;
  location: string;
  category_id: number;
  type: "LOTTERY" | "CHECKOUT" | "FREE";
}

export interface THardwareInventoryItem {
  id: number;
  sku_code: string;
  total_quantity: number;
  available_quantity: number;
  sku: THardwareSku;
}

export const toInventoryItems = (
  items: Array<{
    id: number;
    sku_code: string;
    total_quantity: number;
    available_quantity: number;
  }>,
  skus: THardwareSku[]
): THardwareInventoryItem[] => {
  const skuByCode = new Map(skus.map((sku) => [sku.code, sku]));

  return items.flatMap((item) => {
    const sku = skuByCode.get(item.sku_code);
    if (!sku) return [];

    return [
      {
        id: item.id,
        sku_code: item.sku_code,
        total_quantity: item.total_quantity,
        available_quantity: item.available_quantity,
        sku,
      },
    ];
  });
};
